import { render } from "./EdgeProjectionPage.vue?vue&type=template&id=5d420833"
import script from "./EdgeProjectionPage.vue?vue&type=script&lang=js"
export * from "./EdgeProjectionPage.vue?vue&type=script&lang=js"

import "./EdgeProjectionPage.vue?vue&type=style&index=0&id=5d420833&lang=css"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__